module.exports = __webpack_public_path__ + "img/activity8.5d7aea0b.jpg";